document.addEventListener("DOMContentLoaded", () => {
    // !-----------------------------------------------------------------!
    // Открытие менюшки

    function showMenu(button, list) {
        const btn = document.querySelector(`.${button}`),
            menu = document.querySelector(`.${list}`),
            links = menu.querySelectorAll("a"),
            closeBtn = menu.querySelector('.header__nav_close_js');
        shadowBlock = document.querySelector('.shadow_js');

        //плашка с кнопками
        let track = document.querySelector('.track');
        let scrollPosition = window.scrollY || window.pageYOffset;

        if (1) {
            btn.addEventListener("click", (e) => {
                e.stopPropagation(); // Предотвращаем всплытие события
                menu.classList.toggle("-active");
                shadowBlock.classList.toggle("-active");
                // если на мобилке, скрою плашку с кнопками
                if (window.innerWidth < 767) {
                    track.classList.add('track--hidden');
                }
            });

            // логика для кнопки закрыть
            closeBtn.addEventListener("click", (e) => {
                e.stopPropagation(); // Предотвращаем всплытие события
                menu.classList.toggle("-active");
                shadowBlock.classList.toggle("-active");

                // узнаю насколько проскролен документ и нужно ли показывать плашку
                scrollPosition = window.scrollY || window.pageYOffset;
                // если на мобилке, верну плашку с кнопками
                if (window.innerWidth < 767 && scrollPosition > 290) {
                    track.classList.remove('track--hidden');
                }
            });

            // скрыть меню после нажатия на ссылку
            links.forEach(elem => {
                elem.addEventListener("click", () => {
                    menu.classList.toggle("-active");
                    shadowBlock.classList.toggle("-active");
                });
            });

            // Предотвращаем закрытие при клике внутри меню
            menu.addEventListener("click", (e) => {
                e.stopPropagation();
            });
        }
    }

    function showLang(button, list) {
        const btn = document.querySelector(`.${button}`),
            menu = document.querySelector(`.${list}`),
            links = menu.querySelectorAll("a");

        if (1) {
            btn.addEventListener("click", (e) => {
                e.stopPropagation(); // Предотвращаем всплытие события
                menu.classList.toggle("-active");
            });

            // скрыть меню после нажатия на ссылку
            links.forEach(elem => {
                elem.addEventListener("click", () => {
                    menu.classList.toggle("-active");
                });
            });

            // Предотвращаем закрытие при клике внутри меню языков
            menu.addEventListener("click", (e) => {
                e.stopPropagation();
            });
        }
    }

// Добавляем обработчик клика на документе для закрытия всех меню
    document.addEventListener("click", () => {
        const navMenu = document.querySelector(".header__nav_js");
        const shadowBlock = document.querySelector('.shadow_js');
        const langMenu = document.querySelector(".header__lang_list_js");
        const track = document.querySelector('.track');
        let scrollPosition = window.scrollY || window.pageYOffset;

        // Закрываем меню навигации, если оно открыто
        if (navMenu && navMenu.classList.contains("-active")) {
            navMenu.classList.remove("-active");
            shadowBlock.classList.remove("-active");

            // Если на мобилке и проскроллено, возвращаем плашку
            if (window.innerWidth < 767 && scrollPosition > 290) {
                track.classList.remove('track--hidden');
            }
        }

        // Закрываем меню языков, если оно открыто
        if (langMenu && langMenu.classList.contains("-active")) {
            langMenu.classList.remove("-active");
        }
    });

    showMenu("header__burger_js", "header__nav_js");
    showLang("header__lang_btn_js", "header__lang_list_js");


    //    Слайдеры
    try {
        const showroom__slider = new Carousel(document.querySelector(".showroom__slider_js"), {
            Dots: true,
            Navigation: false,
        });

        const near__slider = new Carousel(document.querySelector(".location__near_js"), {
            Dots: false,
            Navigation: true,
            infinite: false
        });

        const products__slider = document.querySelectorAll(".products__slider_js");
        products__slider.forEach(elem => {
            new Carousel(elem, {
                Navigation: false,
            })
        });

        const objects__slider = document.querySelectorAll(".objects__slider_js");
        objects__slider.forEach(elem => {
            new Carousel(elem, {
                Navigation: false,
                Dots: false,
                infinite: false
            })
        });

        const infrastructure__slider = new Carousel(document.querySelector(".infrastructure__slider"), {
            Dots: true,
            Navigation: false,
        });

    } catch (e) {
    }
    try {
        const spGalleryMobile_js = new Carousel(document.querySelector(".spGalleryMobile_js"), {
            Dots: false,
            Navigation: false,
            infinite: false
        });
        const near__slider = new Carousel(document.querySelector(".location__near_js"), {
            Dots: false,
            Navigation: false,
            infinite: false
        });


        const sp__bedrooms_gallery = new Carousel(document.querySelector(".sp__bedrooms_gallery_js"), {
            Dots: false,
            Navigation: false,
            infinite: false,
            center: false
        });


    } catch (e) {

    }

    // Похожие объекты
    try {
        const similar__slider = new Carousel(document.querySelector(".similar__slider_js"), {
            Dots: false,
            Navigation: false,
            infinite: false,
            center: false
        });
    } catch (e) {

    }

    const hideTrack = () => {
        const tracks = document.querySelectorAll('.scrolled_watch_js');

        // Проверяем, что плашки существуют
        if (tracks.length === 0) return;

        // Добавляем дебаунс для оптимизации производительности
        let scrollTimer;
        let resizeTimer;

        // Функция для проверки положения скролла и применения к каждой плашке
        const applyTrackVisibility = () => {
            const scrollPosition = window.scrollY || window.pageYOffset;
            const documentHeight = Math.max(
                document.body.scrollHeight,
                document.body.offsetHeight,
                document.documentElement.clientHeight,
                document.documentElement.scrollHeight,
                document.documentElement.offsetHeight
            );
            const windowHeight = window.innerHeight;
            const distanceToBottom = documentHeight - (scrollPosition + windowHeight);

            tracks.forEach(track => {
                // На мобильных применяем логику скролла
                if (scrollPosition > 290 && distanceToBottom > 240) {
                    track.classList.remove('scrolled_watch--hidden');
                } else {
                    track.classList.add('scrolled_watch--hidden');
                }
            });
        };

        function handleScroll() {
            if (scrollTimer) clearTimeout(scrollTimer);
            scrollTimer = setTimeout(applyTrackVisibility, 100);
        }

        // Добавляем обработчик события скролла
        window.addEventListener('scroll', handleScroll);

        // Вызываем функцию при загрузке, чтобы установить начальное состояние
        applyTrackVisibility();

        // Также обновляем при изменении размера окна
        window.addEventListener('resize', function () {
            if (resizeTimer) clearTimeout(resizeTimer);
            resizeTimer = setTimeout(applyTrackVisibility, 100);
        });
    }
    hideTrack();


    //    Выключить автофокус у фенсибокс
    Fancybox.bind("[data-fancybox]", {
        autoFocus: false,
        // click: false,
        dragToClose: false,
        clickOutside: "close",
    });
    // !-----------------------------------------------------------------!

    // !-----------------------------------------------------------------!


    // QUIZ

    const quiz = () => {
        // Получаем элементы формы
        const quizForm = document.getElementById('quiz__form');
        const steps = document.querySelectorAll('.quiz__step');
        const progressLine = document.querySelector('.quiz__progress__line');
        const currentStepCounter = document.querySelector('.quiz__progress__current');
        const totalSteps = steps.length;

        // Устанавливаем общее количество шагов
        document.querySelector('.quiz__progress__total').textContent = `/ ${totalSteps}`;

        // Скрытые поля для хранения выбранных значений
        const hiddenFields = {
            projectType: document.getElementById('project_type'),
            areaSize: document.getElementById('area_size'),
            budget: document.getElementById('budget'),
            currentStep: document.getElementById('current_step')
        };

        // Инициализация - показываем только первый шаг
        let currentStep = 1;
        updateProgressBar();

        // Удаляем кнопки "Далее" (они нам больше не нужны)
        document.querySelectorAll('.quiz__btn--next').forEach(button => {
            button.style.display = 'none';
        });

        // Обработчик выбора опции с автоматическим переходом к следующему шагу
        document.querySelectorAll('.quiz__option').forEach(option => {
            option.addEventListener('click', function () {
                // Проверяем, не происходит ли уже анимация перехода
                if (document.querySelector('.quiz__step.transitioning')) {
                    return; // Предотвращаем двойной клик
                }

                // Находим родительский шаг и делаем его активным
                const step = this.closest('.quiz__step');
                const stepNumber = parseInt(step.dataset.step);

                // Снимаем активный класс со всех опций текущего шага
                step.querySelectorAll('.quiz__option').forEach(opt => {
                    opt.classList.remove('active');
                });

                // Делаем текущую опцию активной
                this.classList.add('active');

                // Получаем значение выбранной опции
                const value = this.dataset.value;

                // Сохраняем значение в соответствующее скрытое поле
                saveOptionValue(stepNumber, value);

                // Если это не последний шаг, автоматически переходим к следующему через 0.4 секунды
                if (stepNumber < totalSteps) {
                    // Добавляем класс для анимации исчезновения
                    step.classList.add('transitioning', 'fadeOut');

                    setTimeout(() => {
                        // Переходим к следующему шагу
                        goToStep(stepNumber + 1);
                    }, 400); // 400ms для соответствия требованию 0.4 секунды
                }
            });
        });

        // Функция сохранения значения в скрытое поле
        function saveOptionValue(stepNumber, value) {
            switch (stepNumber) {
                case 1:
                    hiddenFields.projectType.value = value;
                    break;
                case 2:
                    hiddenFields.areaSize.value = value;
                    break;
                case 3:
                    hiddenFields.budget.value = value;
                    break;
            }
        }

        // Обработчики кнопки "Назад"
        document.querySelectorAll('.quiz__btn--prev').forEach(button => {
            button.addEventListener('click', function () {
                const currentStepElement = this.closest('.quiz__step');
                const prevStepNumber = parseInt(currentStepElement.dataset.step) - 1;

                if (prevStepNumber >= 1) {
                    // Добавляем класс для анимации исчезновения
                    currentStepElement.classList.add('transitioning', 'fadeOut');

                    setTimeout(() => {
                        goToStep(prevStepNumber);
                    }, 400);
                }
            });
        });

        // Функция перехода к определенному шагу
        function goToStep(stepNumber) {
            // Скрываем все шаги
            steps.forEach(step => {
                step.classList.remove('active', 'transitioning', 'fadeOut', 'fadeIn');
                step.style.display = 'none';
            });

            // Показываем нужный шаг
            const targetStep = document.querySelector(`.quiz__step[data-step="${stepNumber}"]`);
            targetStep.classList.add('active', 'transitioning', 'fadeIn');
            targetStep.style.display = 'block';

            // Убираем класс анимации после завершения
            setTimeout(() => {
                targetStep.classList.remove('transitioning', 'fadeIn');
            }, 400);

            // Обновляем текущий шаг
            currentStep = stepNumber;
            hiddenFields.currentStep.value = currentStep;

            // Обновляем прогресс-бар
            updateProgressBar();
        }

        // Функция обновления прогресс-бара
        function updateProgressBar() {
            const progressPercentage = (currentStep / totalSteps) * 100;
            progressLine.style.width = `${progressPercentage}%`;
            currentStepCounter.textContent = currentStep;
        }

        // Обработчик отправки формы
        quizForm.addEventListener('submit', function (e) {
            e.preventDefault();

            // отключил кнопку
            const btn = quizForm.querySelector('.quiz__btn--submit');
            btn.disabled = true; // отключил кнопку
            btn.style.opacity = "0.6";

            // Собираем данные формы
            const formData = new FormData(quizForm);
            const formDataObj = {};

            formData.forEach((value, key) => {
                formDataObj[key] = value;
            });

            console.log('Данные для отправки:', formDataObj);

            // Здесь вы можете добавить свою логику отправки данных
            getData("/fn", formData)
                .then(data => showPopup(data, quizForm));
        });

        // Валидация полей на последнем шаге
        const nameInput = document.getElementById('name');
        const phoneInput = document.getElementById('phone');
        const agreeCheckbox = document.getElementById('agree');
        const submitButton = document.querySelector('.quiz__btn--submit');

        function validateLastStep() {
            const isNameValid = nameInput.value.trim() !== '';
            const isPhoneValid = phoneInput.value.trim() !== '';
            const isAgreed = agreeCheckbox.checked;

            // Проверяем валидность полей
            submitButton.disabled = !(isNameValid && isPhoneValid && isAgreed);
        }

        // Добавляем обработчики событий для полей последнего шага
        nameInput.addEventListener('input', validateLastStep);
        phoneInput.addEventListener('input', validateLastStep);
        agreeCheckbox.addEventListener('change', validateLastStep);

        // Инициализируем валидацию при загрузке страницы
        validateLastStep();
    }
    // quiz();

    // QUIZ END


    // CATALOG
    const catalog = () => {
        document.querySelectorAll('.catalog__select_elem').forEach(button => {
            button.addEventListener('click', () => {
                const type = button.dataset.type;
                document.querySelectorAll('.catalog__select_elem').forEach(btn => btn.classList.remove('-active'));
                button.classList.add('-active');

                document.querySelectorAll('.size__m2').forEach(elem => {
                    elem.style.display = type === 'm2' ? 'inline' : 'none';
                });
                document.querySelectorAll('.size__ft2').forEach(elem => {
                    elem.style.display = type === 'ft2' ? 'inline' : 'none';
                });
            });
        });
    }
    catalog();
    // CATALOG END


    // GALLERY
    const gallery = () => {
        const locals = window.SHOW_MORE_LOCALS;
        const lang = 'current';

        console.log(lang);

        // Конфигурация галереи с учетом текущего размера экрана
        let ITEMS_VISIBLE_DEFAULT = window.innerWidth <= 1364 ? 1000 : 6;
        const ITEMS_TO_ADD = 3;

        // Текущая активная галерея
        let activeGalleryType = 'exteriors';

        // Элементы DOM
        const galleryButton = document.querySelector('.gallery__button button');
        const galleryButtonContainer = document.querySelector('.gallery__button');

        //  если нет объектов - выйду из функции
        if (!galleryButton || !galleryButtonContainer) return

        // Функция для инициализации состояния галереи
        function initGallery(forceUpdate = false) {
            // Скрыть или показать элементы в зависимости от ITEMS_VISIBLE_DEFAULT
            document.querySelectorAll('.gallery__grid').forEach(gallery => {
                const items = gallery.querySelectorAll('a');

                // Если элементов больше чем ITEMS_VISIBLE_DEFAULT, регулируем их видимость
                if (items.length > ITEMS_VISIBLE_DEFAULT) {
                    for (let i = 0; i < items.length; i++) {
                        // Если в пределах видимых элементов или принудительное обновление - показываем
                        if (i < ITEMS_VISIBLE_DEFAULT || forceUpdate) {
                            items[i].style.display = '';
                        } else {
                            items[i].style.display = 'none';
                        }
                    }
                } else {
                    // Если элементов меньше чем лимит, показываем все
                    items.forEach(item => item.style.display = '');
                }
            });

            // Установить состояние кнопки
            updateButtonVisibility();
        }

        // Обработка нажатия на переключатели галереи
        document.querySelectorAll('.gallery__select_elem').forEach(button => {
            button.addEventListener('click', () => {
                // Получаем тип галереи из data-атрибута
                const type = button.dataset.type;
                activeGalleryType = type;

                // Убираем активный класс у всех кнопок и добавляем к текущей
                document.querySelectorAll('.gallery__select_elem').forEach(btn => {
                    btn.classList.remove('-active');
                });
                button.classList.add('-active');

                // Скрываем все блоки галереи
                document.querySelectorAll('.gallery__exteriors, .gallery__interiors').forEach(gallery => {
                    gallery.style.display = 'none';
                });

                // Показываем нужный блок с правильным display
                if (window.innerWidth <= 1365) {
                    document.querySelector(`.gallery__${type}`).style.display = 'flex';
                } else {
                    document.querySelector(`.gallery__${type}`).style.display = 'grid';
                }

                // Обновляем состояние кнопки "Показать больше"
                updateButtonVisibility();
            });
        });

        // Обработчик кнопки "Показать больше"/"Скрыть"
        galleryButton.addEventListener('click', () => {
            const currentGallery = document.querySelector(`.gallery__${activeGalleryType}`);
            const items = currentGallery.querySelectorAll('a');
            const visibleItems = Array.from(items).filter(item => item.style.display !== 'none');

            if (galleryButton.textContent === locals[lang][0]) {
                // Режим "Показать больше"
                let itemsToShow = 0;

                for (let i = visibleItems.length; i < items.length && itemsToShow < ITEMS_TO_ADD; i++) {
                    items[i].style.display = '';
                    itemsToShow++;
                }

                // Проверяем, остались ли еще скрытые элементы
                if (visibleItems.length + itemsToShow >= items.length) {
                    galleryButton.textContent = locals[lang][1];
                }
            } else {
                // Режим "Скрыть"
                // Скрываем все, кроме первых ITEMS_VISIBLE_DEFAULT
                for (let i = ITEMS_VISIBLE_DEFAULT; i < items.length; i++) {
                    items[i].style.display = 'none';
                }

                galleryButton.textContent = locals[lang][0];

                // Плавная прокрутка к началу блока
                const galleryContainer = document.querySelector('.gallery');
                galleryContainer.scrollIntoView({behavior: 'smooth'});
            }
        });

        // Функция для обновления видимости кнопки "Показать больше"
        function updateButtonVisibility() {
            const currentGallery = document.querySelector(`.gallery__${activeGalleryType}`);
            const items = currentGallery.querySelectorAll('a');

            // Если элементов не больше, чем ITEMS_VISIBLE_DEFAULT, скрываем кнопку
            if (items.length <= ITEMS_VISIBLE_DEFAULT) {
                galleryButtonContainer.style.display = 'none';
            } else {
                galleryButtonContainer.style.display = '';
                galleryButton.textContent = locals[lang][0];
            }
        }

        // Инициализация галереи
        initGallery();

        // Инициализация - показываем экстерьеры при загрузке страницы
        document.querySelector('.gallery__interiors').style.display = 'none';

        // Возвращаем функцию, которая обновит видимость элементов
        return {
            updateVisibility: () => {
                // Обновляем значение в зависимости от текущего размера окна
                ITEMS_VISIBLE_DEFAULT = window.innerWidth <= 1364 ? 1000 : 6;
                // Принудительно обновляем отображение элементов
                initGallery(true);
            }
        };
    };

// Инициализируем галерею и сохраняем ссылку на метод обновления
    const galleryInstance = gallery();

// Обработчик изменения размера окна
    window.addEventListener("resize", function () {
        // Вызываем метод обновления видимости элементов
        galleryInstance.updateVisibility();
    });
    // GALLERY END

    /**
     * Создает и управляет dots-навигацией для галереи только на iOS устройствах
     */
    const GalleryDots = () => {
        // Проверяем, является ли устройство iOS
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

        // if (!isIOS) return; // Если не iOS, прекращаем выполнение

        // Основные селекторы галереи
        const galleryGrids = document.querySelectorAll('.gallery__grid');

        // Создаем dots для каждой галереи
        galleryGrids.forEach(gallery => {
            const galleryType = gallery.classList.contains('gallery__exteriors') ? 'exteriors' : 'interiors';
            const galleryItems = gallery.querySelectorAll('a');

            if (galleryItems.length === 0) return;

            // Создаем контейнер для точек
            const dotsContainer = document.createElement('div');
            dotsContainer.className = `gallery-dots gallery-dots--${galleryType}`;
            dotsContainer.style.cssText = `
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 15px;
            width: 100%;
            gap: 8px;
        `;

            // Если галерея скрыта, скрываем и dots
            if (gallery.style.display === 'none') {
                dotsContainer.style.display = 'none';
            }

            // Создаем точки в зависимости от количества элементов
            for (let i = 0; i < galleryItems.length; i++) {
                const dot = document.createElement('span');
                dot.className = 'gallery-dot';
                dot.dataset.index = i;
                dot.dataset.galleryType = galleryType;
                dot.style.cssText = `
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background-color: ${i === 0 ? 'var(--accent)' : 'var(--grayBDC2D3)'};
                transition: background-color 0.3s ease;
                cursor: pointer;
            `;

                // Добавляем обработчик клика для навигации
                dot.addEventListener('click', (e) => {
                    const index = parseInt(e.target.dataset.index);
                    scrollToGalleryItem(gallery, index);
                    updateDots(gallery, index);
                });

                dotsContainer.appendChild(dot);
            }

            // Добавляем контейнер после галереи
            gallery.parentNode.insertBefore(dotsContainer, gallery.nextSibling);

            // Настраиваем прокрутку для этой галереи
            setupGalleryScroll(gallery);
        });

        /**
         * Настраивает отслеживание прокрутки для галереи
         */
        function setupGalleryScroll(gallery) {
            // Определяем текущий видимый элемент при прокрутке
            const intersectionObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                        const index = Array.from(gallery.querySelectorAll('a')).indexOf(entry.target);
                        if (index !== -1) {
                            updateDots(gallery, index);
                        }
                    }
                });
            }, {
                root: null,
                threshold: 0.5 // Элемент считается видимым, когда он виден на 50% или более
            });

            // Наблюдаем за всеми элементами галереи
            gallery.querySelectorAll('a').forEach(item => {
                intersectionObserver.observe(item);
            });

            // Добавляем обработчик прокрутки для мобильного Safari
            gallery.addEventListener('scroll', debounce(() => {
                const items = gallery.querySelectorAll('a');
                const galleryRect = gallery.getBoundingClientRect();
                let closestItem = null;
                let closestDistance = Number.MAX_VALUE;

                items.forEach((item, index) => {
                    const itemRect = item.getBoundingClientRect();
                    const distance = Math.abs(itemRect.left - galleryRect.left);

                    if (distance < closestDistance) {
                        closestDistance = distance;
                        closestItem = item;
                    }
                });

                if (closestItem) {
                    const index = Array.from(items).indexOf(closestItem);
                    updateDots(gallery, index);
                }
            }, 100));
        }

        /**
         * Обновляет состояние точек
         */
        function updateDots(gallery, activeIndex) {
            const galleryType = gallery.classList.contains('gallery__exteriors') ? 'exteriors' : 'interiors';
            const dots = document.querySelectorAll(`.gallery-dots--${galleryType} .gallery-dot`);

            dots.forEach((dot, index) => {
                dot.style.backgroundColor = index === activeIndex ? 'var(--accent)' : 'var(--grayBDC2D3)';
            });
        }

        /**
         * Прокручивает галерею к указанному элементу
         */
        function scrollToGalleryItem(gallery, index) {
            const items = gallery.querySelectorAll('a');
            if (index >= 0 && index < items.length) {
                items[index].scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                    inline: 'center'
                });
            }
        }

        /**
         * Функция debounce для ограничения вызовов при прокрутке
         */
        function debounce(func, wait) {
            let timeout;
            return function () {
                const context = this;
                const args = arguments;
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    func.apply(context, args);
                }, wait);
            };
        }

        // Добавляем стили для мобильного отображения галереи
        function addMobileGalleryStyles() {
            // Добавляем стиль только если он еще не существует
            if (!document.getElementById('ios-gallery-styles')) {
                const styleSheet = document.createElement('style');
                styleSheet.id = 'ios-gallery-styles';
                styleSheet.innerHTML = `
                @media screen and (max-width: 768px) {
                    .gallery__grid {
                        overflow-x: auto;
                        scroll-snap-type: x mandatory;
                        -webkit-overflow-scrolling: touch;
                        scrollbar-width: none; /* Firefox */
                        -ms-overflow-style: none; /* IE and Edge */
                    }
                    
                    .gallery__grid::-webkit-scrollbar {
                        display: none; /* Chrome and Safari */
                    }
                    
                    .gallery__grid a {
                        flex: 0 0 100%;
                        scroll-snap-align: center;
                        display: flex;
                        justify-content: center;
                        margin-right: 0;
                    }
                    
                    .gallery__grid img {
                        max-width: 100%;
                        height: auto;
                        object-fit: contain;
                    }
                }
            `;
                document.head.appendChild(styleSheet);
            }
        }

        // Обработчик переключения галереи
        function setupGallerySwitching() {
            document.querySelectorAll('.gallery__select_elem').forEach(button => {
                button.addEventListener('click', () => {
                    const type = button.dataset.type;

                    // Обновляем видимость dots-контейнеров при переключении
                    document.querySelectorAll('.gallery-dots').forEach(dotsContainer => {
                        dotsContainer.style.display = 'none';
                    });

                    const activeDotsContainer = document.querySelector(`.gallery-dots--${type}`);
                    if (activeDotsContainer) {
                        activeDotsContainer.style.display = 'flex';
                    }
                });
            });
        }

        // Применяем стили и настраиваем переключение галереи
        addMobileGalleryStyles();
        setupGallerySwitching();
    };
    GalleryDots();


    // ОБЪЕКТЫ С ПЕРЕКЛЮЧАТЕЛЕМ
    const objectWithTabs = () => {
        const locals = window.SHOW_MORE_LOCALS;
        const lang = 'current';

        // Конфигурация с учетом размера экрана
        let ITEMS_VISIBLE_DEFAULT = window.innerWidth <= 1364 ? 1000 : 2;
        const ITEMS_TO_ADD = 1;

        // Функция для инициализации одного контейнера
        function initContainer(container) {
            const selectButtons = container.querySelectorAll('.obj__select_elem_js');
            const grid = container.querySelector('.objects__grid_js');
            const moreButton = container.querySelector('.obj__button_js');
            const moreButtonContainer = container.querySelector('.obj__button_container_js');

            let activeType = 'rent'; // По умолчанию первый активный
            if (!grid || !selectButtons || !moreButton || !moreButtonContainer) return

            // Инициализация видимости элементов
            function updateVisibility(forceUpdate = false) {
                const items = Array.from(grid.querySelectorAll('.obj__elem_js')).filter(item => item.dataset.type === activeType);
                if (items.length <= ITEMS_VISIBLE_DEFAULT) {
                    moreButtonContainer.style.display = 'none';
                    items.forEach(item => item.style.display = '');
                } else {
                    moreButtonContainer.style.display = '';
                    moreButton.textContent = locals[lang][0];
                    items.forEach((item, index) => {
                        item.style.display = (index < ITEMS_VISIBLE_DEFAULT || forceUpdate) ? '' : 'none';
                    });
                }
            }

            // Переключение типов
            selectButtons.forEach(button => {
                button.addEventListener('click', () => {
                    activeType = button.dataset.type;
                    selectButtons.forEach(btn => btn.classList.remove('-active'));
                    button.classList.add('-active');

                    // Скрываем все элементы и показываем только с нужным data-type
                    grid.querySelectorAll('.obj__elem_js').forEach(item => {
                        item.style.display = (item.dataset.type === activeType) ? '' : 'none';
                    });

                    // Обновляем кнопку "больше"
                    updateVisibility();
                });
            });

            // Обработчик кнопки "больше/скрыть"
            moreButton.addEventListener('click', () => {
                const items = Array.from(grid.querySelectorAll('.obj__elem_js')).filter(item => item.dataset.type === activeType && item.style.display !== 'none');
                if (moreButton.textContent === locals[lang][0]) {
                    // Показать больше
                    const allItems = Array.from(grid.querySelectorAll('.obj__elem_js')).filter(item => item.dataset.type === activeType);
                    let itemsShown = 0;
                    for (let i = items.length; i < allItems.length && itemsShown < ITEMS_TO_ADD; i++) {
                        allItems[i].style.display = '';
                        itemsShown++;
                    }
                    if (items.length + itemsShown >= allItems.length) {
                        moreButton.textContent = locals[lang][1];
                    }
                } else {
                    // Скрыть
                    updateVisibility();
                    container.scrollIntoView({behavior: 'smooth'});
                }
            });

            // Начальная инициализация
            selectButtons.forEach(btn => {
                if (btn.classList.contains('-active')) {
                    activeType = btn.dataset.type;
                }
            });
            grid.querySelectorAll('.obj__elem_js').forEach(item => {
                item.style.display = (item.dataset.type === activeType) ? '' : 'none';
            });
            updateVisibility();
        }

        // Инициализируем все контейнеры
        document.querySelectorAll('.obj_js').forEach(initContainer);

        // Функция обновления на resize
        return {
            updateVisibility: () => {
                ITEMS_VISIBLE_DEFAULT = window.innerWidth <= 1364 ? 1000 : 6;
                document.querySelectorAll('.obj_js').forEach(container => {
                    const grid = container.querySelector('.objects__grid_js');
                    const activeType = container.querySelector('.gallery__select_elem_js.-active').dataset.type;
                    grid.querySelectorAll('.obj__elem_js').forEach(item => {
                        item.style.display = (item.dataset.type === activeType) ? '' : 'none';
                    });
                    // Принудительное обновление видимости
                    const items = Array.from(grid.querySelectorAll('.obj__elem_js')).filter(item => item.dataset.type === activeType);
                    if (items.length > ITEMS_VISIBLE_DEFAULT) {
                        for (let i = ITEMS_VISIBLE_DEFAULT; i < items.length; i++) {
                            items[i].style.display = 'none';
                        }
                        container.querySelector('.gallery__button_js').textContent = locals[lang][0];
                    }
                });
            }
        };
    };

    objectWithTabs()

    // LOCATION
    const location = () => {
        const scrollContainer = document.querySelector('.location__near_grid');

        // Переменные для отслеживания состояния перетаскивания
        let isDown = false;
        let startX;
        let scrollLeft;

        // Обработчики событий мыши
        scrollContainer.addEventListener('mousedown', (e) => {
            isDown = true;
            scrollContainer.style.cursor = 'grabbing';
            startX = e.pageX - scrollContainer.offsetLeft;
            scrollLeft = scrollContainer.scrollLeft;

            // Предотвращаем выделение текста при перетаскивании
            e.preventDefault();
        });

        scrollContainer.addEventListener('mouseleave', () => {
            isDown = false;
            scrollContainer.style.cursor = 'grab';
        });

        scrollContainer.addEventListener('mouseup', () => {
            isDown = false;
            scrollContainer.style.cursor = 'grab';
        });

        scrollContainer.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - scrollContainer.offsetLeft;
            const walk = (x - startX) * 5; // Скорость прокрутки (можно настроить)
            scrollContainer.scrollLeft = scrollLeft - walk;
        });

        // Добавляем стиль курсора по умолчанию
        scrollContainer.style.cursor = 'grab';

        // Предотвращаем стандартный клик при перетаскивании
        const links = scrollContainer.querySelectorAll('a');
        links.forEach(link => {
            let linkWasClicked = false;
            let dragStarted = false;

            link.addEventListener('mousedown', () => {
                linkWasClicked = true;
                dragStarted = false;
            });

            link.addEventListener('mousemove', () => {
                if (linkWasClicked) {
                    dragStarted = true;
                }
            });

            link.addEventListener('click', (e) => {
                if (dragStarted) {
                    e.preventDefault();
                }
            });
        });
    }
    // location()
    // LOCATION END


    // FAQ
    // Их нужно называть также, как
    const accordion = (term) => {
        const faqItems = document.querySelectorAll(term);

        class FaqManager {
            constructor(items, options = {}) {
                this.items = items;
                this.options = {
                    multipleOpen: false,
                    animationDuration: 400,
                    ...options
                };

                this.init();
            }

            init() {
                this.items.forEach(item => {
                    const title = item.querySelector(term + '_title');
                    const content = item.querySelector(term + '_info');

                    if (item.classList.contains('-active')) {
                        // content.style.height = `${content.scrollHeight}px`;
                        // content.style.height = `calc(${content.scrollHeight}px * var(--scale-factor-up)`;
                        content.style.height = `auto`;
                        content.style.opacity = '1';
                        content.style.display = 'block';
                    }

                    title.addEventListener('click', () => this.toggleItem(item));
                });
            }

            async toggleItem(clickedItem) {
                const isActive = clickedItem.classList.contains('-active');

                // Собираем все элементы, которые нужно анимировать
                let itemsToAnimate = [];

                if (!this.options.multipleOpen && !isActive) {
                    // Добавляем все активные элементы для закрытия
                    itemsToAnimate = Array.from(this.items)
                        .filter(item => item !== clickedItem && item.classList.contains('-active'))
                        .map(item => ({
                            item,
                            action: 'close'
                        }));
                }

                // Добавляем кликнутый элемент
                itemsToAnimate.push({
                    item: clickedItem,
                    action: isActive ? 'close' : 'open'
                });

                // Запускаем все анимации одновременно
                await Promise.all(
                    itemsToAnimate.map(({item, action}) =>
                        action === 'open' ? this.openItem(item) : this.closeItem(item)
                    )
                );
            }

            async openItem(item) {
                const content = item.querySelector(term + '_info');
                content.style.display = 'block';

                const targetHeight = content.scrollHeight;
                content.style.height = '0px';
                content.style.opacity = '0';

                const keyframes = [
                    {height: '0px', opacity: 0},
                    {height: `${targetHeight}px`, opacity: 1}
                ];

                const animation = content.animate(keyframes, {
                    duration: this.options.animationDuration,
                    easing: 'ease-in-out',
                    fill: 'forwards'
                });

                // await animation.finished;
                animation.finished;

                item.classList.add('-active');
                content.style.height = 'auto';
                content.style.opacity = '1';
            }

            async closeItem(item) {
                const content = item.querySelector(term + '_info');
                const startHeight = content.scrollHeight;

                const keyframes = [
                    {height: `${startHeight}px`, opacity: 1},
                    {height: '0px', opacity: 0}
                ];

                const animation = content.animate(keyframes, {
                    duration: this.options.animationDuration,
                    easing: 'ease-in-out',
                    fill: 'forwards'
                });

                await animation.finished;
                // animation.finished;

                item.classList.remove('-active');
                content.style.display = 'none';
            }
        }

        // Инициализация
        const faqManager = new FaqManager(faqItems, {
            multipleOpen: false,
            animationDuration: 400
        });
    }
    accordion('.location__advantages__content .faq__elem');
    accordion('.faq__list .faq__elem');
    // FAQ END


    // Ленивая загрузка фото
    /*! lozad.js - v1.14.0 - 2019-10-31
    * https://github.com/ApoorvSaxena/lozad.js
    * Copyright (c) 2019 Apoorv Saxena; Licensed MIT */


    (function (global, factory) {
        typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
            typeof define === 'function' && define.amd ? define(factory) :
                (global.lozad = factory());
    }(this, (function () {
        'use strict';

        /**
         * Detect IE browser
         * @const {boolean}
         * @private
         */
        var isIE = typeof document !== 'undefined' && document.documentMode;

        var defaultConfig = {
            rootMargin: '800px', // определеяет когда будет загрузка изображений (сделал ее чуть по раньше, изначально было 0)
            threshold: 0,
            load: function load(element) {
                if (element.nodeName.toLowerCase() === 'picture') {
                    var img = document.createElement('img');
                    if (isIE && element.getAttribute('data-iesrc')) {
                        img.src = element.getAttribute('data-iesrc');
                    }

                    if (element.getAttribute('data-alt')) {
                        img.alt = element.getAttribute('data-alt');
                    }

                    element.append(img);
                }

                if (element.nodeName.toLowerCase() === 'video' && !element.getAttribute('data-src')) {
                    if (element.children) {
                        var childs = element.children;
                        var childSrc = void 0;
                        for (var i = 0; i <= childs.length - 1; i++) {
                            childSrc = childs[i].getAttribute('data-src');
                            if (childSrc) {
                                childs[i].src = childSrc;
                            }
                        }

                        element.load();
                    }
                }

                if (element.getAttribute('data-poster')) {
                    element.poster = element.getAttribute('data-poster');
                }

                if (element.getAttribute('data-src')) {
                    element.src = element.getAttribute('data-src');
                }

                if (element.getAttribute('data-srcset')) {
                    element.setAttribute('srcset', element.getAttribute('data-srcset'));
                }

                if (element.getAttribute('data-background-image')) {
                    element.style.backgroundImage = 'url(\'' + element.getAttribute('data-background-image').split(',').join('\'),url(\'') + '\')';
                } else if (element.getAttribute('data-background-image-set')) {
                    var imageSetLinks = element.getAttribute('data-background-image-set').split(',');
                    var firstUrlLink = imageSetLinks[0].substr(0, imageSetLinks[0].indexOf(' ')) || imageSetLinks[0]; // Substring before ... 1x
                    firstUrlLink = firstUrlLink.indexOf('url(') === -1 ? 'url(' + firstUrlLink + ')' : firstUrlLink;
                    if (imageSetLinks.length === 1) {
                        element.style.backgroundImage = firstUrlLink;
                    } else {
                        element.setAttribute('style', (element.getAttribute('style') || '') + ('background-image: ' + firstUrlLink + '; background-image: -webkit-image-set(' + imageSetLinks + '); background-image: image-set(' + imageSetLinks + ')'));
                    }
                }

                if (element.getAttribute('data-toggle-class')) {
                    element.classList.toggle(element.getAttribute('data-toggle-class'));
                }
            },
            loaded: function loaded() {
            }
        };

        function markAsLoaded(element) {
            element.setAttribute('data-loaded', true);
        }

        var isLoaded = function isLoaded(element) {
            return element.getAttribute('data-loaded') === 'true';
        };

        var onIntersection = function onIntersection(load, loaded) {
            return function (entries, observer) {
                entries.forEach(function (entry) {
                    if (entry.intersectionRatio > 0 || entry.isIntersecting) {
                        observer.unobserve(entry.target);

                        if (!isLoaded(entry.target)) {
                            load(entry.target);
                            markAsLoaded(entry.target);
                            loaded(entry.target);
                        }
                    }
                });
            };
        };

        var getElements = function getElements(selector) {
            var root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

            if (selector instanceof Element) {
                return [selector];
            }

            if (selector instanceof NodeList) {
                return selector;
            }

            return root.querySelectorAll(selector);
        };

        function lozad() {
            var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.lozad';
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var _Object$assign = Object.assign({}, defaultConfig, options),
                root = _Object$assign.root,
                rootMargin = _Object$assign.rootMargin,
                threshold = _Object$assign.threshold,
                load = _Object$assign.load,
                loaded = _Object$assign.loaded;

            var observer = void 0;

            if (typeof window !== 'undefined' && window.IntersectionObserver) {
                observer = new IntersectionObserver(onIntersection(load, loaded), {
                    root: root,
                    rootMargin: rootMargin,
                    threshold: threshold
                });
            }

            return {
                observe: function observe() {
                    var elements = getElements(selector, root);

                    for (var i = 0; i < elements.length; i++) {
                        if (isLoaded(elements[i])) {
                            continue;
                        }

                        if (observer) {
                            observer.observe(elements[i]);
                            continue;
                        }

                        load(elements[i]);
                        markAsLoaded(elements[i]);
                        loaded(elements[i]);
                    }
                },
                triggerLoad: function triggerLoad(element) {
                    if (isLoaded(element)) {
                        return;
                    }

                    load(element);
                    markAsLoaded(element);
                    loaded(element);
                },

                observer: observer
            };
        }

        return lozad;

    })));

    lozad('.lazy').observe();

    // Ленивая загрузка видео с возможностью регулировать порог загрузки
    function lazyLoadVideo() { // threshold по умолчанию установлен в 200px
        let threshold = 200;
        let lazyVideos = document.querySelectorAll(".lazy_video");
        lazyVideos.forEach(function (video) {
            let rect = video.getBoundingClientRect();
            // Изменение условия видимости с учетом порога
            if (rect.top < window.innerHeight + threshold && rect.bottom > -threshold && getComputedStyle(video).display !== "none") {
                let sources = video.querySelectorAll("source");
                sources.forEach(function (source) {
                    source.src = source.dataset.src;
                });
                video.load();
                video.classList.remove("lazy_video");
                // удалю обработчики событий после того как все видео загрузяться и появятся в зоне зрения человека
                if (document.querySelectorAll(".lazy_video").length === 0) {
                    document.removeEventListener("scroll", lazyLoadVideo);
                    window.removeEventListener("resize", lazyLoadVideo);
                    window.removeEventListener("orientationchange", lazyLoadVideo);
                }
            }
        });
    }

// Добавление обработчиков событий
    document.addEventListener("scroll", lazyLoadVideo);
    window.addEventListener("resize", lazyLoadVideo);
    window.addEventListener("orientationchange", lazyLoadVideo);


    // Загрузка всех фото из слайдера
    /**
     * Функция для предзагрузки изображений в слайдерах
     * @param {string} sliderSelector - CSS селектор для контейнеров слайдеров
     * @param {string} imageSelector - CSS селектор для изображений внутри слайдера (по умолчанию '.lazy')
     * @param {string} rootMargin - Отступ для начала загрузки (по умолчанию '500px')
     */
    function initSliderPreload(sliderSelector, imageSelector = '.lazy', rootMargin = '600px') {
        // Находим все слайдеры на странице по переданному селектору
        const sliders = document.querySelectorAll(sliderSelector);
        console.log(sliders);

        if (!sliders.length) return;

        // Функция для загрузки всех изображений в слайдере
        function loadSliderImages(slider) {
            const images = slider.querySelectorAll(imageSelector);
            images.forEach(img => {
                // Если изображение уже загружено, пропускаем его
                if (img.getAttribute('data-loaded') === 'true') return;

                // Обрабатываем data-srcset для обычных изображений
                if (img.getAttribute('data-srcset')) {
                    img.setAttribute('srcset', img.getAttribute('data-srcset'));
                }

                // Обрабатываем data-src для обычных изображений
                if (img.getAttribute('data-src')) {
                    img.src = img.getAttribute('data-src');
                }

                // Обрабатываем data-background-image для элементов с фоновыми изображениями
                if (img.getAttribute('data-background-image')) {
                    img.style.backgroundImage = 'url(\'' + img.getAttribute('data-background-image').split(',').join('\'),url(\'') + '\')';
                }

                // Помечаем изображение как загруженное, чтобы lozad его пропустил
                img.setAttribute('data-loaded', 'true');

                // Если у элемента есть класс для переключения, применяем его
                if (img.getAttribute('data-toggle-class')) {
                    img.classList.toggle(img.getAttribute('data-toggle-class'));
                }
            });
        }

        // Создаем IntersectionObserver для каждого слайдера
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // Загружаем все изображения слайдера, когда он становится видимым
                    loadSliderImages(entry.target);
                    // Отключаем наблюдение за этим слайдером после загрузки изображений
                    observer.unobserve(entry.target);
                }
            });
        }, {rootMargin: rootMargin});

        // Начинаем наблюдение за всеми слайдерами
        sliders.forEach(slider => {
            observer.observe(slider);
        });

        // Возвращаем метод для ручной загрузки слайдера, если он нужен
        return {
            triggerLoad: function (sliderElement) {
                if (sliderElement) {
                    loadSliderImages(sliderElement);
                    observer.unobserve(sliderElement);
                }
            }
        };
    }

// Инициализация после загрузки DOM
    const showroomPreloader = initSliderPreload('.showroom__slider_js');
    const infrastructure__slider = initSliderPreload('.infrastructure__slider');
    const location__near_js = initSliderPreload('.location__near_js');
    // Сделаю логику для слайдера с интерьером и экстерьером который виден только на определенном экране
    if (window.innerWidth <= 1364) {
        const gallery__exteriors = initSliderPreload('.gallery__exteriors');
        const gallery__interiors = initSliderPreload('.gallery__interiors');
    }


    // -------------- preventDefault --------------------
    function removeLink() {
        try {
            let a_arr = document.querySelectorAll(".remove_link");
            a_arr.forEach(elem => {
                elem.addEventListener("click", (e) => {
                    e.preventDefault();
                });
            });
        } catch (e) {
            console.log("Нет ссылок для удаления")
        }
    }

    removeLink();
    // -------------- preventDefault END --------------------


//    Убрать лишний текст из форм
    function addPoliticaText() {
        try {
            let tags = document.querySelectorAll(".politica_js");
            tags.forEach(elem => {
                elem.innerHTML = `Нажимая на кнопку, Вы даете согласие на обработку персональных данных в соответствии <a href="./Политика конфиденциальности.docx">с&nbsp;политикой конфиденциальности`
            })
        } catch (e) {
            console.log("Нет текста из форм")
        }
    }

    addPoliticaText();

//  Нормальный скрол до элементов
    function fixScrollToAnchor() {
        // Получите высоту вашей шапки
        let header = document.querySelector('#header');
        let headerHeight = header.offsetHeight + 20;

        // Обработчик события для якорных ссылок
        header.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', (e) => {
                e.preventDefault();

                // Получите ID элемента, к которому нужно прокрутить страницу
                const targetId = anchor.getAttribute('href').substring(1);

                // Найдите целевой элемент
                const targetElement = document.getElementById(targetId);

                if (targetElement) {
                    // Вычислите позицию для прокрутки с учетом высоты шапки
                    const scrollToPosition = targetElement.offsetTop - headerHeight;

                    // Используйте метод scrollTop для прокрутки страницы с плавной анимацией
                    window.scrollTo({
                        top: scrollToPosition,
                        behavior: 'smooth'
                    });
                }
            });

        });
    }

    fixScrollToAnchor();

    // Скрыть шапку при скроле
    /* function hideHeader() {
         if (window.innerWidth > 768) {
             let lastScrollTop = 0;
             let header = document.querySelector("#header");
             window.addEventListener("scroll", function () {
                 let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

                 if (scrollTop > lastScrollTop) {
                     // Скролл вниз
                     header.classList.add("scroll");
                 } else {
                     // Скролл вверх
                     header.classList.remove("scroll");
                 }

                 lastScrollTop = scrollTop;
             });
         }
     }
     hideHeader();*/

    // Скрипт для автомасштабирования
    /*document.addEventListener("DOMContentLoaded", () => {
        // Функция для обновления scale-factor-up
        function updateScaleFactor() {
            const root = document.documentElement;
            const viewportWidth = window.innerWidth;
            let scaleFactor;

            // Проверяем, мобильное устройство или ПК
            if (viewportWidth <= 767) { // Обычно 768px считается границей между мобильными и десктопными устройствами
                // Для мобильных устройств (базовый размер 375px)
                scaleFactor = Math.max(0.8, viewportWidth / 400);
            } else if (viewportWidth <= 1366) {
                // Для ПК (базовый размер 1480px)
                scaleFactor = Math.max(0.9229729, viewportWidth / 768);
            }


            else {
                // Для ПК (базовый размер 1480px)
                scaleFactor = Math.max(0.9229729, viewportWidth / 1480);
            }

            root.style.setProperty('--scale-factor-up', scaleFactor);
        }

        // Обновление при изменении размера окна
        window.addEventListener('resize', updateScaleFactor);

        // Начальное применение scale-фактора
        updateScaleFactor();
    });*/


    Fancybox.bind('a[href="#popup_layout"]', {
        on: {
            // При открытии: добавляем текст в hidden-поле
            'Carousel.contentReady': function(fancyboxRef, carouselRef, slide) {
                const url = slide.triggerEl.dataset.url || '';
                const messageField = slide.el.querySelector('#object_interest'); // Новый селектор
                if (messageField && url) {

                    messageField.value = 'Интересует объект ' + url;
                    // Фокус на первое видимое поле (имя), если нужно
                    const nameField = slide.el.querySelector('.lead-form__input[type="text"]');
                    if (nameField) nameField.focus();
                }
            },
            // При закрытии: очищаем поле (на случай, если передумали)
            close: function(fancyboxRef) {
                const slide = fancyboxRef.getSlide();
                if (slide) {
                    const messageField = slide.el.querySelector('#object_interest');
                    if (messageField) {
                        messageField.value = '';
                    }
                }
            }
        }
    });

});
